/* eslint-disable quote-props */
import { getRawUrl, getUrl } from '@albacross/frontend-utils'

const urls = {
  login: 'login',
  'login.mfa': 'login_mfa',
  account: 'account',
  dataChangeRequests: 'data-change-requests',
  'dataChangeRequests.view': 'data-change-requests/:id',
  nameToDomain: 'name-to-domain',
  campaigns: 'campaigns',
  'campaigns.review': 'campaigns/review',
  campaign: 'campaigns/:id',
  'campaign.tab': 'campaigns/:id/:tab',
  'campaign.edit': 'campaigns/:id/edit',
  'campaign.review': 'campaigns/review/:id',
  'campaign.targets.match': 'campaigns/:id/targets/match',
  companies: 'companies',
  company: 'companies/:uuid',
  customers: 'customers',
  customer: 'customers/:id/:tab?',
  'customer.edit': 'customers/:id/edit',
  users: 'users',
  user: 'users/:id',
  'user.edit': 'users/:id/edit',
  reveal: 'reveal',
  enrich: 'enrich',
}

export const UrlProvider = {
  getUrl: getUrl(urls),
  getRawUrl: getRawUrl(urls),
}
